"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TimeConfig", {
  enumerable: true,
  get: function get() {
    return _timeService.TimeConfig;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "getTimeSettings", {
  enumerable: true,
  get: function get() {
    return _timeService.getTimeSettings;
  }
});
Object.defineProperty(exports, "timeFormatKeys", {
  enumerable: true,
  get: function get() {
    return _timeService.timeFormatKeys;
  }
});
Object.defineProperty(exports, "timeZoneKeys", {
  enumerable: true,
  get: function get() {
    return _timeService.timeZoneKeys;
  }
});
Object.defineProperty(exports, "timeZoneVisibilityKeys", {
  enumerable: true,
  get: function get() {
    return _timeService.timeZoneVisibilityKeys;
  }
});

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _Loader = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Loader"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _panel = _interopRequireDefault(require("@insided/deprecated-control/panel"));

var _timeService = require("@insided/shared/services/timeService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getOption = function getOption(option) {
  return (0, _preact.h)("div", {
    key: option.key
  }, (0, _preact.h)("div", {
    className: "option-title"
  }, option.title), option.description ? (0, _preact.h)("div", {
    className: "option-desc"
  }, option.description) : null);
};

var timeFormats = [{
  key: _timeService.timeFormatKeys.automatic,
  title: 'Automatic (default)',
  description: 'The time format is rendered based on the user’s current locale'
}, {
  key: _timeService.timeFormatKeys.ampm,
  title: 'AM/PM',
  description: 'All events will be shown in the AM/PM format'
}, {
  key: _timeService.timeFormatKeys.hours24,
  title: '24-hours',
  description: 'All events will be shown in the 24-hours format'
}];
var timeZones = [{
  key: _timeService.timeZoneKeys.user,
  title: 'User’s local time zone (default)',
  description: 'All event times are rendered in the current user’s time zone, regardless of the timezone set in the event'
}, {
  key: _timeService.timeZoneKeys.local,
  title: 'Event’s time zone',
  description: 'All event times are rendered in the time zone specified in the event'
}];
var timeZoneVisibilities = [{
  key: _timeService.timeZoneVisibilityKeys.display,
  title: 'Display the time zone (default)'
}, {
  key: _timeService.timeZoneVisibilityKeys.hide,
  title: 'Hide the time zone'
}];
var optionsTimeFormat = timeFormats.map(function (timeFormatOption) {
  return getOption(timeFormatOption);
});
var optionsTimeZone = timeZones.map(function (timeZoneOption) {
  return getOption(timeZoneOption);
});
var optionsTimeZoneVisibility = timeZoneVisibilities.map(function (timeZoneVisibilityOption) {
  return getOption(timeZoneVisibilityOption);
});

var EventSettings = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventSettings, _Component);

  var _super = _createSuper(EventSettings);

  function EventSettings(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventSettings);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveChanges", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, timeFormat, timeZone, timeZoneVisibility;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, timeFormat = _this$state.timeFormat, timeZone = _this$state.timeZone, timeZoneVisibility = _this$state.timeZoneVisibility;

              _this.setState({
                messageType: undefined,
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return _axios.default.post('/settings/configuration/saveTimeSettings', {
                config: {
                  timeFormat: timeFormats[timeFormat !== null && timeFormat !== void 0 ? timeFormat : 0].key,
                  timeZone: timeZones[timeZone !== null && timeZone !== void 0 ? timeZone : 0].key,
                  timeZoneVisibility: timeZoneVisibilities[timeZoneVisibility !== null && timeZoneVisibility !== void 0 ? timeZoneVisibility : 0].key
                },
                modules: []
              });

            case 5:
              _this.setState({
                isLoading: false,
                messageType: 'success',
                message: 'Event Settings successfully saved.'
              });

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              _this.setState({
                message: 'Failed to save event settings.',
                messageType: 'error',
                isLoading: false
              });

              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    })));
    _this.state = {
      isLoading: false,
      messageType: null,
      message: '',
      timeFormat: null,
      timeZone: null,
      timeZoneVisibility: null
    };
    return _this;
  }

  (0, _createClass2.default)(EventSettings, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.get('/settings/eventSettings', {
                  headers: {
                    Accept: 'application/json'
                  }
                });

              case 4:
                res = _context2.sent;
                this.setState({
                  isLoading: false,
                  timeFormat: timeFormats.findIndex(function (option) {
                    return option.key === res.data.config.timeFormat;
                  }),
                  timeZone: timeZones.findIndex(function (option) {
                    return option.key === res.data.config.timeZone;
                  }),
                  timeZoneVisibility: timeZoneVisibilities.findIndex(function (option) {
                    return option.key === res.data.config.timeZoneVisibility;
                  })
                });
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  message: 'Failed to fetch event settings.',
                  messageType: 'error',
                  isLoading: false
                });
                throw _context2.t0;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          messageType = _this$state2.messageType,
          message = _this$state2.message,
          isLoading = _this$state2.isLoading,
          timeFormat = _this$state2.timeFormat,
          timeZone = _this$state2.timeZone,
          timeZoneVisibility = _this$state2.timeZoneVisibility;
      return (0, _preact.h)("div", {
        className: "event-settings qa-event-settings",
        "data-bounded-context": "Event",
        "data-entity": "event-settings"
      }, (0, _preact.h)("div", {
        className: "control-header"
      }, (0, _preact.h)("h2", null, "Event Settings"), (0, _preact.h)(_Button.default, {
        key: "save-changes",
        className: "event-settings-save-button",
        variant: "primary",
        title: "Save Changes",
        onClick: this.onSaveChanges
      })), isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)("div", {
        className: "control-body"
      }, messageType ? (0, _preact.h)(_message.default, {
        isControl: true,
        renderHTML: true,
        variant: messageType,
        message: message,
        onDismiss: function onDismiss() {
          _this2.setState({
            messageType: undefined
          });
        }
      }) : null, (0, _preact.h)("div", null, (0, _preact.h)(_panel.default, {
        title: "Time Zone",
        customClass: "event-settings-panel"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "Time format",
        options: optionsTimeFormat,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            timeFormat: idx
          });
        },
        value: timeFormat !== null ? optionsTimeFormat[timeFormat] : '',
        withRadioIcons: true
      }), (0, _preact.h)(_RadioInputGroup.default, {
        title: "Render the event times in",
        options: optionsTimeZone,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            timeZone: idx,
            timeZoneVisibility: idx === 1 ? 0 : timeZoneVisibility
          });
        },
        value: timeZone !== null ? optionsTimeZone[timeZone] : '',
        withRadioIcons: true
      }), (0, _preact.h)(_RadioInputGroup.default, {
        title: "Time zone visibility",
        options: optionsTimeZoneVisibility,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            timeZoneVisibility: idx
          });
        },
        value: timeZoneVisibility !== null ? optionsTimeZoneVisibility[timeZoneVisibility] : '',
        disabled: timeZone === 1,
        withRadioIcons: true
      })))));
    }
  }]);
  return EventSettings;
}(_preact.Component);

var _default = EventSettings;
exports.default = _default;